var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("DefaultWidget", {
        staticClass: "view-video-snapshot-grid",
        attrs: {
          disabled: _vm.disabled,
          name: "查看预览图",
          icon: "mdi-image-multiple-outline",
        },
        on: { click: _vm.viewSnapshotGrid },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }